<span *ngIf="drone?.streamingStatus == 'waitingDroneInput'">
  <i class="fas fa-circle mid-icon mid-status-off"></i>
  <span>{{ drone?.name }}: {{ 'WAITING_LIVE_STREAM' | translate }}</span>
</span>

<span *ngIf="drone?.streamingStatus == 'streaming'">
  <i class="fas fa-circle mid-icon mid-status-streaming"></i>
  <span>{{ drone?.name }}: {{ 'LIVE_STREAM_ON' | translate }}</span>
</span>
